export const breakPoints = {
  phone: '@media (max-width: 420px)',
  tablet: '@media (max-width: 720px)',
  computer: '@media (max-width: 900px)',
}